// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"logo-android"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M1 18C1 11.9249 5.92487 7 12 7C18.0751 7 23 11.9249 23 18V19H1V18Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M6.11656 8.70397L4 5M6.11656 8.70397C3.04126 10.6544 1 14.0888 1 18V19H23V18C23 14.0888 20.9587 10.6544 17.8834 8.70397M6.11656 8.70397C7.81804 7.62485 9.83605 7 12 7C14.164 7 16.182 7.62485 17.8834 8.70397M17.8834 8.70397L20 5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M7 14H7.00391V14.0039H7V14Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M17 14H17.0039V14.0039H17V14Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]}]};

@tag('t-icon-logo-android')
export default class LogoAndroidIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-android',
    }
  }
}
